export * from './validateCEP'
export * from './validateCNH'
export * from './validateCNPJ'
export * from './validateCNS'
export * from './validateCPF'
export * from './validateCTPS'
export * from './validateDate'
export * from './validateDateAfterToday'
export * from './validateDateBeforeToday'
export * from './validateDateIsOneOfThisWeekDays'
export * from './validateEmail'
export * from './validateFileExtension'
export * from './validateFileSize'
export * from './validateHour'
export * from './validateName'
export * from './validatePhone'
export * from './validatePIS'
export * from './validateRG'
export * from './validateVoterCertificate'
